import {db,} from "../db";
import ContextualVideoLink from '../components/ContextualVideoLink';
import {
    signin,
    getTokens,
    getAccountFromGoogle,
    updateAccount,
    updateUsernameAccount,
    registerHostingService,
    updateOpenAIKey,
    updateGoogleAPIKey,
    getUndeliveredImages,
    getWhmcsData,
    getGoogleAuth,
    register,
    nodeTestGet,
    resetPassword,
    logoutApiSession,
    getSubscription,
    getApiBaseUrl,
    getUsersMonthlyCredits,
    getAuthorizationToken,
    getSubscriptionPortal,
    getCosyflowCategories,
    createLongLifeAPIKey,
    setLongLifeAPIKey,
    clearLongLifeAPIKey,
    getSubscriptionActive,
    verifyAndLoginWithApiKey
} from "../api-helper";
import { storeEncryptedPassword } from "../utils/encryption";
import CloseIcon from "../images/icons/white-close.svg";
import {useEffect, useState, useRef} from "react";
import { useInternetBypass } from '../hooks/useInternetConnectivity';
import { useAccountContext, useAccountContextDispatch } from "../context/AccountContext";
import TokenIcon from '../images/icons/promptus-token.svg';
import PasswordHidden from '../images/icons/input-bar-icons/icon-input-bar-password-hidden.svg';
import PasswordShown from '../images/icons/input-bar-icons/icon-input-bar-password-shown.svg';
import ChevronRight from '../images/icons/chevron-right.svg';
import GoogleIcon from '../images/icons/icon-auth-google.svg';
import Swal from "sweetalert2";
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import { isUndefined } from "cropperjs";
import { useCollectionContextDispatch } from "../context/CollectionContext";
import hostingLogo from '../images/mb_logo.png';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import electronBridge from '../utils/electronBridge';
import axios from "axios";
import { useUndeliveredImages } from "../hooks";
import { analyzeImage, classifyAlpha } from "../alpha-inspector-browser";
import ModelCanvas from "../components/3DCanvas";
import { setFreeUserFlag, isLifetimeLicence, isApiKeyAccount } from '../utils/accountTypes';
import { generateImage } from '../byteplusClient.js';

export default function Profile() {
    const [loading, setLoading] = useState(false);
    const [logloading, setLogloading] = useState(false);
    const [logoutloading, setLogoutloading] = useState(false);
    const [accountNo, setAccountNo] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [newUsername, setNewUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passSecret, setPassSecret] = useState("")
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [account, setAccount] = useState({});
    const [loggedIn, setLoggedIn] = useState(false);
    const [showChangeUser, setShowChangeUser] = useState(false);
    const [showHostRegister, setShowHostRegister] = useState(false);
    const [showOpenAISettings, setShowOpenAISettings] = useState(false);
    const [showGoogleAPISettings, setShowGoogleAPISettings] = useState(false);
    const [error, setError] = useState("");
    const [changeError, setChangeError] = useState("");
    const [method, setMethod] = useState(false);
    const [managerOpen, setManagerOpen] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [imageMetadata, setImageMetadata] = useState([]);
    const [profilePhoto, setProfilePhoto] = useState(localStorage.getItem("profilePhoto") || "");
    const [showProfilePhoto, setShowProfilePhoto] = useState(false);
    const [showSubscription, setShowSubscription] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const accountContextDispatch = useAccountContextDispatch();
    const accountContext = useAccountContext()
    const collectionContextDispatch = useCollectionContextDispatch();
    const { shouldBypass } = useInternetBypass();
    const { checkingUndeliveredImages } = useUndeliveredImages();

    // Helper function to handle API calls with offline protection
    const handleAPICall = async (apiFunction, fallbackMessage, fallbackValue = null) => {
        if (shouldBypass) {
            console.log(`Profile: Offline mode - ${fallbackMessage}`);
            return fallbackValue;
        }

        try {
            return await apiFunction();
        } catch (error) {
            console.error('Profile API call failed:', error);
            return fallbackValue;
        }
    };

    // Registration state
    const [registerEmail, setRegisterEmail] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [registerConfirmPassword, setRegisterConfirmPassword] = useState("");
    const [registerPasswordVisibility, setRegisterPasswordVisibility] = useState(false);
    const [showRegisterForm, setShowRegisterForm] = useState(false);
    const [registerLoading, setRegisterLoading] = useState(false);
    const [registerError, setRegisterError] = useState("");

    // Reset password state - changing to inline form instead of modal
    const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
    const [resetPasswordEmail, setResetPasswordEmail] = useState("");
    const [resetPasswordLoading, setResetPasswordLoading] = useState(false);
    const [resetPasswordError, setResetPasswordError] = useState("");

    //INPUTS FOR HOSTING SERVICE
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [addressOne, setAddressOne] = useState('');
    const [cityName, setCityName] = useState('');
    const [country, setCountry] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    const [hostingCreated, setHostingCreated] = useState('');
    const [hostingDomain, setHostingDomain] = useState('');
    const [hostingStatus, setHostingStatus] = useState('');
    const [hostingSetupInvoice, setHostingSetupInvoice] = useState('');
    const [hostingSetupInvoiceStatus, setHostingSetupInvoiceStatus] = useState('');
    const [hostingSetupInvoiceAmount, setHostingSetupInvoiceAmount] = useState('');
    const [hostingOrderNumber, setHostingOrderNumber] = useState('');

    const [openAIKey, setOpenAIKey] = useState('');
    const [openAIKeyError, setOpenAIKeyError] = useState("");
    const [showHostingDetails, setShowHostingDetails] = useState(false);

    const [showGoogleSignIn, setShowGoogleSignIn] = useState(true);
    const [externalLoginError, setExternalLoginError] = useState(false)
    const [externalLoginErrorMsg, setExternalLoginErrorMsg] = useState('');
    const location = useLocation();
    const locationState = location.state || {};

    const [allowSetUser , setAllowSetUser] = useState(true);
    const ipcRenderer = electronBridge.ipcRenderer

    const [promptHistory, setPromptHistory] = useState([]);
    const [showPromptHistory, setShowPromptHistory] = useState(false);
    const navigate = useNavigate();

    const [googleAPIKey, setGoogleAPIKey] = useState('');
    const [googleAPIKeyError, setGoogleAPIKeyError] = useState("");
    const [openAIKeyValidating, setOpenAIKeyValidating] = useState(false);
    const [googleAPIKeyValidating, setGoogleAPIKeyValidating] = useState(false);
    const [pendingTab, setPendingTab] = useState(null);
    const [googleSignInLoading, setGoogleSignInLoading] = useState(false);

    const [apiKeyInput, setApiKeyInput] = useState('');
    const [apiKeyEmailInput, setApiKeyEmailInput] = useState('');
    const [apiKeyLoading, setApiKeyLoading] = useState(false);
    const [apiKeyError, setApiKeyError] = useState('');
    const [showApiKeyForm, setShowApiKeyForm] = useState(false);
    const [apiKeyLoginEnabled, setApiKeyLoginEnabled] = useState(false);

    useEffect(() => {
        db.settings.get({ key: 'enable_api_key_login' }).then(setting => {
            if (setting?.value) setApiKeyLoginEnabled(true);
        }).catch(() => {});
    }, []);

    const [report, setReport] = useState(null);
    const [showModelManager, setShowModelManager] = useState(false);
    const [modelFiles, setModelFiles] = useState([]);
    const [modelManagerLoading, setModelManagerLoading] = useState(false);
    const [modelManagerError, setModelManagerError] = useState('');
    const [showManageSub, setShowManageSub] = useState(false)
    const [subPortal, setSubPortal] = useState("")
    const stripeTableRef = useRef(null);

    useEffect(() => {
        if (electronBridge.isElectron) {
            const timer = setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 500);
            return () => clearTimeout(timer);
        }
    }, []);

    const tryProtocolWithFallback = (protocolUrl, fallbackUrl) => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        try {
            iframe.contentWindow.location.href = protocolUrl;
        } catch (e) {
            console.log('[tryProtocolWithFallback] Protocol error:', e);
            window.open(fallbackUrl, '_blank');
        }

        setTimeout(() => {
            if (iframe.parentNode) {
                document.body.removeChild(iframe);
            }
        }, 1000);
    };

    const getSettings = async () => {
        setLoading(true);
        setAccountNo(accountContext.accountDetails.accountNo)
        setAccount(accountContext.accountDetails)
        setLoggedIn(accountContext.loggedIn)
    }

    const fetchWHMCSData = async () => {
        const data = await handleAPICall(
            () => getWhmcsData(accountContext.accountDetails.accountNo),
            'skipping WHMCS data fetch'
        );

        if (data) {
            console.log("WhmcsData: ", data)
            setShowHostingDetails(false)
            if (data && data.whmcsOrderId > 0) {
                setShowHostingDetails(true)
                setHostingCreated(data.dateCreated);
                setHostingDomain(data.domain);
                setHostingStatus(data.whmcsOrderStatus);
                setHostingSetupInvoice(data.whmcsInvoiceId);
                setHostingSetupInvoiceStatus(data.whmcsPaymentStatus);
                setHostingSetupInvoiceAmount(data.whmcsInitialAmount);
                setHostingOrderNumber(data.whmcsOrderNumber)

            }
        }
    };

    const fetchPromptHistory = async () => {
        try {
            const history = await db.history.reverse().toArray();
            setPromptHistory(history);
        } catch (error) {
            console.error("Error fetching prompt history:", error);
        }
    };

    const handlePromptClick = (item) => {
        navigate('/', { state: { prompt: item.prompt, seed: item.seeds[0] } });
    };

    useEffect(() => {
        getSettings().then(() => setLoading(false));
        if (accountContext.loggedIn === true) {
            setAccount(accountContext.accountDetails)
            setOpenAIKey(accountContext.accountDetails.openaiKey || '');
            setGoogleAPIKey(accountContext.accountDetails.googleAPIKey || '');
            setNewUsername(accountContext.accountDetails.alias)
            fetchWHMCSData()
            fetchPromptHistory()
        }
    }, []);

    useEffect(() => {
        if (searchParams.get('openCredits') === 'true' && accountContext.loggedIn) {
            setShowSubscription(true);
            searchParams.delete('openCredits');
            setSearchParams(searchParams, { replace: true });
        }
    }, [searchParams, accountContext.loggedIn, setSearchParams]);

    /**
     * Get the login method
     * @returns {Promise<*>}
     */
    const getMethod = async () => {
        let ip = '';
        if (!shouldBypass) {
            try {
                const response = await fetch('https://api.ipify.org');
                ip = await response.text()
                console.log(ip)
            } catch (error) {
                console.error(error)
            }
        } else {
            console.log('Profile: Offline mode - using default IP');
            ip = 'offline';
        }

        const fullURL = window.location.href;

        return signin(emailAddress, password, ip, fullURL)
        // if (!method) {
        //     return signin(emailAddress, password)
        // } else {
        //     return getAccountFromGoogle(emailAddress)
        // }
    }

    const login = () => {
        setLogloading(true);
        getMethod()
            .then(async (data) => {
                if (data.status === "unverified") {
                    setError(data.message || "Your email address has not been verified yet - please click the link sent to you to verify before you login");
                    setLogloading(false);
                    
                    // Show a more prominent message using Swal for better visibility
                    Swal.fire({
                        title: "Email Verification Required",
                        text: "Please check your email and click the verification link we sent you before logging in.",
                        icon: "info",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#FFB02E"
                    });
                } else {
                    await handleLoginSuccess(data, false);  // Pass the data to the new function
                    
                }
            }).catch(error => {
                console.error("Error during login:", error);
                setLogloading(false);
        });
    }

    const handleApiKeyLogin = async () => {
        setApiKeyLoading(true);
        setApiKeyError('');

        try {
            const result = await verifyAndLoginWithApiKey(apiKeyInput.trim(), apiKeyEmailInput.trim());

            if (result.success) {
                const accountDetails = result.account || {};

                window.localStorage.setItem('apiKey', apiKeyInput.trim());
                if (apiKeyEmailInput.trim()) {
                    window.localStorage.setItem('apiKeyEmail', apiKeyEmailInput.trim());
                }
                localStorage.setItem('account', JSON.stringify({ ...accountDetails, isApiKeyAccount: true }));
                db.account.put({ key: 'accountDetails', value: { ...accountDetails, isApiKeyAccount: true } });

                accountContextDispatch({
                    type: 'apiKeyLogin',
                    accountDetails: accountDetails,
                    tokens: result.credits
                });

                setAccount(accountDetails);
                setAccountNo(accountDetails.accountNo || '');
                setLoggedIn(true);
                setApiKeyInput('');
                setApiKeyEmailInput('');
                setShowApiKeyForm(false);

                Swal.fire({
                    title: 'Logged In',
                    text: 'You have been logged in with your API Key. Cloud features are limited to credit tracking only.',
                    icon: 'success',
                    confirmButtonColor: '#FFB02E',
                    confirmButtonText: 'OK'
                });
            } else {
                setApiKeyError(result.message || 'Verification failed');
            }
        } catch (err) {
            console.error('[API_KEY_LOGIN] Error:', err);
            setApiKeyError('An unexpected error occurred. Please try again.');
        }

        setApiKeyLoading(false);
    };

    const handleLoginSuccess = async (data) => {
        if (data.message) {
            setError(data.message);
            setLogloading(false);
        } else {
            setChangeError("");
            setError("");
            setEmailAddress("");
            setAllowSetUser(true)
            accountContextDispatch({ type: 'login', signin: data.account, passSecret: password });
            // Store password using encryption
            storeEncryptedPassword(password).catch(error => {
                console.error('Failed to store encrypted password:', error);
                // Fallback to plain text if encryption fails
                localStorage.setItem("password", JSON.stringify(password));
            });
            setPassword("");
            setAccount(data.account);
            setNewUsername(data.account.alias);

            let openAIKey = data.account.openaiKey || "";
            setOpenAIKey(openAIKey);
            setAccountNo(data.account.accountNo);
            setLoggedIn(true);

            if (data.account.alias && data.account.alias == "") {
                setAllowSetUser(true)
            }

            // Clear API key account flag if switching from API key login to normal login
            window.sessionStorage.removeItem('isApiKeyAccount');

            // Store session keys in both sessionStorage and localStorage for persistence
            if (data.api_key) {
                window.sessionStorage.setItem("apiKey", data.api_key);
                window.localStorage.setItem("apiKey", data.api_key);
            }

            // Store expiry BEFORE creating long life key (required for getAuthorizationToken to work)
            if (data.api_key_expiry) {
                window.sessionStorage.setItem("apiKeyExpiry", data.api_key_expiry);
                window.localStorage.setItem("apiKeyExpiry", data.api_key_expiry);
            }

            // Create long life API key for worker applications (after both apiKey and expiry are stored)
            if (data.api_key) {
                try {
                    console.log('[Profile] Creating long life API key for accountNo:', data.account.accountNo);
                    const longLifeKeyResponse = await createLongLifeAPIKey(data.account.accountNo);
                    console.log('[Profile] Long life API key response:', longLifeKeyResponse);
                    if (longLifeKeyResponse && !longLifeKeyResponse.error && longLifeKeyResponse.api_key) {
                        await setLongLifeAPIKey(longLifeKeyResponse.api_key, longLifeKeyResponse.api_key_expiry);
                        console.log('[Profile] Long life API key created and stored');
                    } else {
                        console.warn('[Profile] Long life API key response invalid or error:', longLifeKeyResponse);
                    }
                } catch (error) {
                    console.error('[Profile] Failed to create long life API key:', error);
                }
            }

            if (electronBridge.isElectron) {
                console.log(`USING ELECTRON FOR INI ACCOUNTNO: ${JSON.stringify(data)}`);
                ipcRenderer.send("ini-accountNo", data.account.accountNo, data.account.alias, data.api_key)
            }
            localStorage.setItem("account", JSON.stringify(data.account));
            db.account.put({ key: 'accountDetails', value: data.account });

            try {
                await getTokens(data.account.accountNo).then(data => {
                    if (!data.error && data.credits !== undefined) {
                        accountContextDispatch({ type: "tokens", tokens: data.credits });
                    }
                    setLogloading(false);
                });
            } catch (error) {
                console.error("Error fetching tokens during login: ", error);
                // Don't set tokens to 0 on error - keep undefined to prevent false low credit warnings
                console.log('[PROFILE_TOKEN_FETCH] Leaving tokens undefined to prevent false credit warnings');
            }

            try {
                await getSubscription(data.account.accountNo).then(data => {
                    console.log(`TARIFF ID: ${data.tariffId}`);
                    setFreeUserFlag(data.tariffId, data.hasApplicationPurchase);
                })
            } catch (error) {
                console.log(`ERROR retrieving subscription`); 
            }

            fetchWHMCSData();
            
            // Collection loading is handled by NavigationMenu.jsx to avoid duplicate API calls
            setLogloading(false);

            // Clear authenticating flag as login is now complete
            accountContextDispatch({type: "setAuthenticating", value: false});
            navigate('/')
        }
    };

    const logout = async () => {
        setLogoutloading(true)

        // Set logging out flag to prevent session expired popup
        accountContextDispatch({type: "setLoggingOut", value: true});

        // Call API logout endpoint first
        await logoutApiSession();

        accountContextDispatch({type: "logout"})
        
        // Clear localStorage
        localStorage.removeItem("account")
        localStorage.removeItem("password")
        localStorage.removeItem("Generate")
        
        // Clear IndexedDB
        await db.account.where("key").equals("accountDetails").delete()
        await db.history.clear()
        // await db.collection.clear()
        await db.collectedImages.clear()
        // await db.images.clear()
        
        // Clear sessionStorage including API keys
        sessionStorage.removeItem('initialCollectionLoad')
        sessionStorage.removeItem('finishedCollectionLoad')
        sessionStorage.removeItem('apiKey')
        sessionStorage.removeItem('apiKeyExpiry')
        sessionStorage.removeItem('isApiKeyAccount')

        // Clear long life API key
        await clearLongLifeAPIKey();

        setAccountNo("");
        setLoggedIn(false);
        setLogoutloading(false);
        collectionContextDispatch({type: 'resetLoading'});
        setShowHostingDetails(false);
    }

    // Validation function for OpenAI API keys
    const validateOpenAIAPIKey = async (apiKey) => {
        if (!apiKey || apiKey.trim() === '') {
            return { valid: true, message: 'Empty key is valid' }; // Allow empty keys
        }
        
        try {
            const response = await fetch('https://api.openai.com/v1/models', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${apiKey}`,
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.ok) {
                return { valid: true, message: 'API key is valid' };
            } else if (response.status === 401) {
                return { valid: false, message: 'Invalid API key - authentication failed' };
            } else if (response.status === 429) {
                return { valid: true, message: 'API key is valid but rate limited' };
            } else if (response.status === 403) {
                return { valid: false, message: 'API key lacks permissions or is restricted' };
            } else {
                return { valid: false, message: `API validation failed with status ${response.status}` };
            }
        } catch (error) {
            return { valid: false, message: `Validation error: ${error.message}` };
        }
    };

    const changeOpenAPIKey = async () => {
        setOpenAIKeyError(null)
        setOpenAIKeyValidating(true)
        
        // Validate the API key first
        const validation = await validateOpenAIAPIKey(openAIKey);
        setOpenAIKeyValidating(false)
        
        if (!validation.valid) {
            setOpenAIKeyError(validation.message);
            return;
        }
        
        updateOpenAIKey(openAIKey, accountContext.accountDetails.accountNo).then(async data => {
            try {
                if (openAIKey === data.account.openaiKey) {
                    setAccount(data.account);
                    setOpenAIKey(openAIKey);

                    // Update the key in both IndexedDB and context
                    const updated = await db.account.update("accountDetails", { value: data.account });
                    
                    // Also save to localStorage for redundancy
                    localStorage.setItem("account", JSON.stringify(data.account));

                    if (updated) {
                        console.log(`OpenAI Key for account ${accountContext.accountDetails.accountNo} updated successfully.`);
                        
                        // Use the new action type to update the context
                        accountContextDispatch({
                            type: 'updateOpenAIKey', 
                            openaiKey: openAIKey
                        });

                        // Show success message
                        Swal.fire({
                            title: "Success",
                            text: "Your OpenAI Key was successfully changed",
                            icon: "success",
                            timer: 1200,
                            showConfirmButton: false
                        });
                    }
                } else if (data.message){
                    // If server rejects the key but it might be a valid service account key
                    if (openAIKey.startsWith('sk-svcacct-')) {
                        console.log("Service account key detected, storing locally as fallback");
                        
                        // Store in the context
                        accountContextDispatch({
                            type: 'updateOpenAIKey', 
                            openaiKey: openAIKey
                        });
                        
                        // Store in localStorage both ways for redundancy
                        localStorage.setItem('openai_api_key', openAIKey);
                        
                        // Update the account in localStorage
                        try {
                            const localAccount = JSON.parse(localStorage.getItem("account")) || {};
                            localAccount.openaiKey = openAIKey;
                            localStorage.setItem("account", JSON.stringify(localAccount));
                        } catch (err) {
                            console.error("Error updating localStorage account:", err);
                        }
                        
                        // Show message that key is saved locally but not on server
                        Swal.fire({
                            title: "Key Saved Locally",
                            text: "The server rejected this service account key format, but it has been saved locally for use in the MOMM page.",
                            icon: "info",
                            showConfirmButton: true
                        });
                    } else {
                        setOpenAIKeyError(data.message);
                    }
                }
            } catch (error) {
                console.error('Error occurred:', error);
                
                // Fallback for any error
                if (openAIKey.startsWith('sk-')) {
                    console.log("API key format detected, storing locally as fallback due to error");
                    
                    // Store in the context
                    accountContextDispatch({
                        type: 'updateOpenAIKey', 
                        openaiKey: openAIKey
                    });
                    
                    // Store in localStorage both ways for redundancy
                    localStorage.setItem('openai_api_key', openAIKey);
                    
                    // Update the account in localStorage
                    try {
                        const localAccount = JSON.parse(localStorage.getItem("account")) || {};
                        localAccount.openaiKey = openAIKey;
                        localStorage.setItem("account", JSON.stringify(localAccount));
                    } catch (err) {
                        console.error("Error updating localStorage account:", err);
                    }
                    
                    Swal.fire({
                        title: "Key Saved Locally",
                        text: "There was an error saving the key to your profile, but it has been saved locally for use in the MOMM page.",
                        icon: "info",
                        showConfirmButton: true
                    });
                }
            }
        });

        //}
    }

    // Validation function for Google AI Studio API keys (Gemini API)
    const validateGoogleAPIKey = async (apiKey) => {
        if (!apiKey || apiKey.trim() === '') {
            return { valid: true, message: 'Empty key is valid' }; // Allow empty keys
        }
        
        try {
            // Use Google AI Studio (Gemini API) models list endpoint for validation
            const testUrl = `https://generativelanguage.googleapis.com/v1/models?key=${apiKey}`;
            const response = await fetch(testUrl);
            
            if (response.ok) {
                const data = await response.json();
                if (data.models && Array.isArray(data.models)) {
                    return { valid: true, message: 'Google AI Studio API key is valid' };
                } else {
                    return { valid: false, message: 'Invalid response from Google AI Studio API' };
                }
            } else if (response.status === 400) {
                return { valid: false, message: 'Invalid Google AI Studio API key format' };
            } else if (response.status === 403) {
                return { valid: false, message: 'Google AI Studio API key access denied or restricted' };
            } else if (response.status === 429) {
                return { valid: true, message: 'API key is valid but rate limited' };
            } else {
                return { valid: false, message: `Google AI Studio API validation failed with status ${response.status}` };
            }
        } catch (error) {
            return { valid: false, message: `Validation error: ${error.message}` };
        }
    };

    const changeGoogleAPIKey = async () => {
        setGoogleAPIKeyError(null)
        setGoogleAPIKeyValidating(true)
        
        // Validate the API key first
        const validation = await validateGoogleAPIKey(googleAPIKey);
        setGoogleAPIKeyValidating(false)
        
        if (!validation.valid) {
            setGoogleAPIKeyError(validation.message);
            return;
        }
        
        updateGoogleAPIKey(googleAPIKey, accountContext.accountDetails.accountNo).then(async data => {
            try {
                // Check if data exists and has the expected structure
                if (data && data.account && googleAPIKey === data.account.googleAPIKey) {
                    setAccount(data.account);
                    setGoogleAPIKey(googleAPIKey);

                    // Update the key in both IndexedDB and context
                    const updated = await db.account.update("accountDetails", { value: data.account });
                    
                    // Also save to localStorage for redundancy
                    localStorage.setItem("account", JSON.stringify(data.account));

                    if (updated) {
                        console.log(`Google API Key for account ${accountContext.accountDetails.accountNo} updated successfully.`);
                        
                        // Use the new action type to update the context
                        accountContextDispatch({
                            type: 'updateGoogleAPIKey', 
                            googleAPIKey: googleAPIKey
                        });

                        // Show success message
                        Swal.fire({
                            title: "Success",
                            text: "Your Google API Key was successfully changed",
                            icon: "success",
                            timer: 1200,
                            showConfirmButton: false
                        });
                    }
                } else if (data && data.message) {
                    setGoogleAPIKeyError(data.message);
                    
                    // Still save the key locally even if server has an error message
                    saveGoogleAPIKeyLocally();
                } else {
                    // If server response doesn't match expectations, still save locally
                    console.log("Server response doesn't contain expected data structure, saving key locally");
                    saveGoogleAPIKeyLocally();
                }
            } catch (error) {
                console.error('Error updating Google API key:', error);
                // Fallback for any error
                saveGoogleAPIKeyLocally();
            }
        }).catch(error => {
            console.error('Network error updating Google API key:', error);
            // Fallback for network errors
            saveGoogleAPIKeyLocally();
        });
        
        // Helper function to save the key locally
        function saveGoogleAPIKeyLocally() {
            if (googleAPIKey.length > 5) {
                console.log("Google API key format detected, storing locally");
                
                // Store in the context
                accountContextDispatch({
                    type: 'updateGoogleAPIKey', 
                    googleAPIKey: googleAPIKey
                });
                
                // Store in localStorage both ways for redundancy
                localStorage.setItem('google_api_key', googleAPIKey);
                
                // Update the account in localStorage
                try {
                    const localAccount = JSON.parse(localStorage.getItem("account")) || {};
                    localAccount.googleAPIKey = googleAPIKey;
                    localStorage.setItem("account", JSON.stringify(localAccount));
                } catch (err) {
                    console.error("Error updating localStorage account:", err);
                }
                
                Swal.fire({
                    title: "Key Saved",
                    text: "Your Google API Key has been saved locally",
                    icon: "success",
                    timer: 1200,
                    showConfirmButton: false
                });
            }
        }
    }

    const changeUsername = () => {

        //if (account.alias.toLowerCase() == newUsername.toLocaleLowerCase()) {
        // ** CONTROLLED BY THE API SO USERNAME EXISTS DOESN'T OCCUR WHEN SAVING CURRENT USERNAME
        //    setChangeError("Community alias already exists");
        //} else {
            if (newUsername == "") {
                setChangeError("Please add a username");
            } else if (newUsername.includes("_")) {
                setChangeError("The _ character is not allowed in your username");
            } else if (newUsername.startsWith("-") || newUsername.endsWith("-")) {
                setChangeError("The - characters is not allowed at the beginning/end of your username");
            } else if (/[A-Z]/.test(newUsername)) {
                setChangeError("Uppercase letters are not allowed");
            } else {
                setLogloading(true);
                updateUsernameAccount(newUsername, accountNo)
                .then((data) => {
                    console.log(data)
                    let updateError = false;
                    setChangeError("");
                    if (data.message != "") {
                        updateError = true;
                        setChangeError(data.message);
                    }
                    accountContextDispatch({type: 'login', signin: data.account, passSecret: JSON.parse(localStorage.getItem("password"))})
                    setAccount(data.account);
                    localStorage.setItem("account", JSON.stringify(data.account))
                    db.account.put({key: 'accountDetails', value: data.account})
                    db.collectedImages.bulkAdd(JSON.parse(data.account.images))
                    setAccountNo(data.account.accountNo)
                    if (!updateError) {
                        setNewUsername(data.account.alias);
                    } else {
                        setNewUsername(newUsername);
                    }
                    setLoggedIn(true);
                    try {
                        getTokens(data.account.accountNo)
                        .then(data => {
                            if (!data.error && data.credits !== undefined) {
                                accountContextDispatch({type : "tokens", tokens: data.credits})
                            }
                            setLogloading(false);
                            if (!updateError) {
                                Swal.fire({
                                    title: "Success",
                                    text: "Your username was successfully changed",
                                    icon: "success",
                                    timer: 1200,
                                    showConfirmButton: false
                                })
                            }
                        })                    
                    } catch (error) {
                        console.error("Error updating tokens on username change: ", error);
                        // Don't set tokens to 0 on error - keep undefined to prevent false low credit warnings
                        console.log('[PROFILE_USERNAME_TOKEN_FETCH] Leaving tokens undefined to prevent false credit warnings');
                    }
                })
            }
        //}
    }

    const handleProfilePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setProfilePhoto(base64String);
                localStorage.setItem("profilePhoto", base64String);
                // Dispatch a custom event to notify other components
                window.dispatchEvent(new Event('profilePhotoChanged'));
            };
            reader.readAsDataURL(file);
        }
    };
    
    const clearProfilePhoto = () => {
        setProfilePhoto("");
        localStorage.removeItem("profilePhoto");
        // Dispatch a custom event to notify other components
        window.dispatchEvent(new Event('profilePhotoChanged'));
    };

    const fetchModelFiles = async () => {
        setModelManagerLoading(true);
        setModelManagerError('');
        try {
            const cosySetting = await db.settings.get({ key: 'local_cosy' });
            const cosyUrl = cosySetting?.value || 'http://localhost:8190/';
            const baseUrl = cosyUrl.endsWith('/') ? cosyUrl.slice(0, -1) : cosyUrl;
            const response = await axios.get(`${baseUrl}/api/generate/get-models`);
            const allFiles = response.data || [];
            const safetensorFiles = allFiles.filter(f => f.filename.endsWith('.safetensors'));
            setModelFiles(safetensorFiles);
        } catch (error) {
            console.error('Error fetching model files:', error);
            setModelManagerError('Could not connect to cosyflow server. Make sure it is running.');
        } finally {
            setModelManagerLoading(false);
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + units[i];
    };

    const handleOpenManager = () => {
        console.log(`Open manager button pressed`);
        const isApiKey = isApiKeyAccount(accountContext.accountDetails);

        if (electronBridge.isElectron) {
            if (isApiKey) {
                const email = window.localStorage.getItem('apiKeyEmail') || '';
                const apiKey = window.localStorage.getItem('apiKey') || '';
                ipcRenderer.send('open-pmanager-apikey', email, apiKey);
            } else {
                ipcRenderer.send('open-pmanager', accountContext.accountDetails.accountNo, accountContext.accountDetails.alias, window.localStorage.getItem('longLifeAPIKey'));
            }
        } else {
            if (isApiKey) {
                const email = window.localStorage.getItem('apiKeyEmail') || '';
                const apiKey = window.localStorage.getItem('apiKey') || '';
                const protocolUrl = `promptus-pm:/email=${email},apiKey=${apiKey}`;
                window.location.href = protocolUrl;
            } else {
                const protocolUrl = `promptus-pm:/accountNo=${accountContext.accountDetails.accountNo},alias=${accountContext.accountDetails.alias},apiKey=${window.localStorage.getItem('longLifeAPIKey')}`;
                const fallbackUrl = `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`;
                tryProtocolWithFallback(protocolUrl, fallbackUrl);
            }
        }
    }

    const handleKeyDownEmail = (e) => {
        if (e.key === "Enter" || e.keyCode == 13) {
            login()
        }
    };

    const handleKeyDownGmail = (e) => {
        if (e.key === "Enter" || e.keyCode == 13) {
            login()
        }
      };

    const registerService = () => {
        console.log("Registering");
        registerHostingService(accountNo,account.emailAddress,account.alias)
    }

    const tester = async () => {
        try {
        const apiKey = window.localStorage.getItem('apiKey') || window.sessionStorage.getItem('apiKey');
            if (!apiKey) {
                console.error('[TESTER] No API key found');
                return;
            }
        console.log('[TESTER] Calling Bytedance Seedream API...');    
        const data = await generateImage({
            apiKey,
            model: "seedream-5-0-260128",
            prompt: "Vibrant close-up editorial portrait, model with piercing gaze, wearing a sculptural hat, rich color blocking, sharp focus on eyes, shallow depth of field, Vogue magazine cover aesthetic, shot on medium format, dramatic studio lighting.",
            size: "2K",
            watermark: false
        });

        console.log('[TESTER] Returned Data: ',data);
        } catch (err) {
        setError(err.message || 'Something went wrong');
        } finally {
        setLoading(false);
        }
    }

    
    useEffect(() => {
        getWhmcsData(accountContext.accountDetails.accountNo).then(async(data) => {
            console.log("WhmcsData: ", data)

            if (data && data.whmcsOrderId > 0) {
                setShowHostingDetails(true)
                setHostingCreated(data.dateCreated);
                setHostingDomain(data.domain);
                setHostingStatus(data.whmcsOrderStatus);
                setHostingSetupInvoice(data.whmcsInvoiceId);
                setHostingSetupInvoiceStatus(data.whmcsPaymentStatus);
                setHostingSetupInvoiceAmount(data.whmcsInitialAmount);
                setHostingOrderNumber(data.whmcsOrderNumber)

            }
        });
    }, [accountContext.accountDetails.accountNo]);

    const viewPublicGallery = () => {
        if (accountContext.accountDetails.alias && accountContext.accountDetails.alias !== 's') {
            if (electronBridge.isElectron) {
                ipcRenderer.send('open-urlInExternal', `https://${accountContext.accountDetails.alias}.promptus.ai`)
            } else {
                window.open(`https://${accountContext.accountDetails.alias}.promptus.ai`, "_blank");
            }
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have a username for your public gallery. Please create your username.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }) 
        }
    }

    // Removed pre-fetching of Google auth URL to improve initial page load performance
    // Auth URL is now fetched only when user clicks the button



    useEffect(() => {
        // Get the query parameter using URLSearchParams from React Router location
        const queryParams = new URLSearchParams(location.search);
        const googleLogin = queryParams.get('err');

        if (googleLogin === "general_error") {
            setExternalLoginError(true);
            setExternalLoginErrorMsg('Unfortunately, we could not log you in with this email address');
        } else if (googleLogin === "account_not_found") {
            setExternalLoginError(true);
            setExternalLoginErrorMsg('No Promptus account found.');
        }

        // Handle form parameter for login/register switching (only if user is not logged in)
        const formParam = queryParams.get('form');
        if (!accountContext.loggedIn && formParam) {
            if (formParam === 'register') {
                setShowRegisterForm(true);
                console.log('Profile: Setting register form from URL parameter');
            } else if (formParam === 'login') {
                setShowRegisterForm(false);
                console.log('Profile: Setting login form from URL parameter');
            }

            // Clear the form parameter from URL to keep it clean
            queryParams.delete('form');
            const newSearch = queryParams.toString();
            const newUrl = newSearch ? `${location.pathname}?${newSearch}` : location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }

        // Check for tab in state first, then fall back to query params
        const tabFromState = locationState.tab;
        const tabFromQuery = queryParams.get('tab');
        const tab = tabFromState || tabFromQuery;
        
        console.log('Profile: Tab from state:', tabFromState, 'Tab from query:', tabFromQuery);
        console.log('Profile: Final tab:', tab, 'Logged in:', accountContext.loggedIn);
        console.log('Profile: location.state:', location.state);
        
        if (tab === 'openai' || tab === 'google') {
            // Use a small timeout to ensure component is fully mounted
            setTimeout(() => {
                // If already logged in, open the tab immediately
                if (accountContext.loggedIn) {
                    console.log('Profile: User is logged in, opening tab:', tab);
                    if (tab === 'openai') {
                        setShowOpenAISettings(true);
                    } else if (tab === 'google') {
                        setShowGoogleAPISettings(true);
                    }
                    
                    // Clear the state after use to prevent persistence
                    if (tabFromState) {
                        window.history.replaceState({}, document.title);
                    }
                } else {
                    // Store for later when logged in
                    console.log('Profile: User not logged in, storing tab for later:', tab);
                    setPendingTab(tab);
                }
            }, 100);
        }
    }, [location, accountContext.loggedIn, locationState.tab]);

    // Handle opening the pending tab when user is logged in
    useEffect(() => {
        console.log('Profile: Pending tab check - Logged in:', accountContext.loggedIn, 'Pending tab:', pendingTab);
        if (accountContext.loggedIn && pendingTab) {
            console.log('Profile: Opening pending tab:', pendingTab);
            if (pendingTab === 'openai') {
                setShowOpenAISettings(true);
            } else if (pendingTab === 'google') {
                setShowGoogleAPISettings(true);
            }
            setPendingTab(null); // Clear after use
        }
    }, [accountContext.loggedIn, pendingTab]);

    const handleGoogleSignIn = async() => {
        try {
            setGoogleSignInLoading(true);

            // Set authenticating flag to prevent session expired popup during auth process
            accountContextDispatch({type: "setAuthenticating", value: true});

            const data = await getGoogleAuth();
            console.log(data);

            // Use electronBridge which handles both Electron and browser environments
            electronBridge.authenticateWithGoogle(data.authUrl);
        } catch (error) {
            console.error("Google Sign-In error:", error);
            alert("Failed to initiate Google Sign-In. Please try again.");
            // Clear authenticating flag on error
            accountContextDispatch({type: "setAuthenticating", value: false});
        } finally {
            setGoogleSignInLoading(false);
        }
    };

    const handleRegister = async () => {
        // Reset any previous errors
        setRegisterError("");
        
        // Validate form
        if (!registerEmail) {
            setRegisterError("Email address is required");
            return;
        }
        
        if (!registerPassword) {
            setRegisterError("Password is required");
            return;
        }
        
        if (registerPassword !== registerConfirmPassword) {
            setRegisterError("Passwords do not match");
            return;
        }
        
        setRegisterLoading(true);
        
        try {
            // Fetch IP address
            let ip_address = '';
            try {
                const ipResponse = await fetch('https://api.ipify.org');
                ip_address = await ipResponse.text();
                console.log('Registration IP:', ip_address);
            } catch (error) {
                console.error('Failed to fetch IP address:', error);
            }
            
            // Get user agent
            const user_agent = navigator.userAgent;
            console.log('Registration User Agent:', user_agent);
            
            const response = await register(registerEmail, registerPassword, ip_address, user_agent);
            
            if (response.message) {
                // Check if this is an error message or a verification notification
                if (response.status === "unverified" || response.message.includes("verify") || response.message.includes("verification")) {
                    // This is a verification notification, not an error
                    setRegisterLoading(false);
                    
                    // Prefill login form with registration details
                    setEmailAddress(registerEmail);
                    setPassword(registerPassword);
                    
                    // Reset registration form
                    setRegisterEmail("");
                    setRegisterPassword("");
                    setRegisterConfirmPassword("");
                    
                    // Return to login view
                    setShowRegisterForm(false);
                    
                    // Show verification message
                    Swal.fire({
                        title: "Verify Your Email",
                        text: "We've sent a verification link to your email address. Please check your inbox and click the link to verify your account before logging in.",
                        icon: "info",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#FFB02E"
                    });
                } else {
                    // This is an actual error message
                    setRegisterError(response.message);
                    setRegisterLoading(false);
                }
            } else {
                // Registration successful
                setRegisterLoading(false);
                
                // Prefill login form with registration details
                setEmailAddress(registerEmail);
                setPassword(registerPassword);
                
                // Reset registration form
                setRegisterEmail("");
                setRegisterPassword("");
                setRegisterConfirmPassword("");
                
                // Return to login view
                setShowRegisterForm(false);
                
                // Show success message
                Swal.fire({
                    title: "Registration Successful",
                    text: "Your account has been created. You can now log in.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error("Registration error: ", error);
            setRegisterError("Registration failed. Please try again.");
            setRegisterLoading(false);
        }
    };

    const handleKeyDownRegister = (e) => {
        if (e.key === 'Enter' && registerEmail && registerPassword && registerPassword === registerConfirmPassword) {
            handleRegister();
        }
    };

    useEffect(() => {
        if (accountContext.accountDetails.alias !== "") {
            console.log(accountContext);
            
            console.log("SETTING SHOW CHANGE USER TO FALSE")
            setAllowSetUser(false)
        }

    }, [accountContext.accountDetails]) 

    const fetchUserPortal = async() => {
        const response = await getSubscriptionPortal();
        console.log('[SubscriptionManage] Response: ', response);
        if (response && !response.error) {
            if (response.url !== "") {
                console.log('[SubscriptionManage] URL received: ', response.url);
                setSubPortal(response.url)
            } else {
                console.log('[SubscriptionManage] URL not received: ', response.url);
                setSubPortal("")
            }
        } else {
            setSubPortal("")
        }
    }

    const fetchSubscriptionStatus = async () => {
        const response = await getSubscriptionActive();
        console.log('[SubscriptionManage] Subscription Active: ', response);

        if (response && !response.error) {
            const isActive = response?.['is_active'] ?? false;
            if (isActive) {
                console.log('[SubscriptionManage] Subscription Active: ', isActive);
                setShowManageSub(true)
            } else {
                console.log('[SubscriptionManage] Subscription Inactive: ', isActive);
                setShowManageSub(false)
            }
        } else {
            setShowManageSub(false)
        }
    }

    useEffect(() => {
        if (accountContext.loggedIn) {
            //fetchUserPortal()
            fetchSubscriptionStatus()
        }
    },[accountContext.accountDetails, accountContext.loggedIn])

    const handleResetPassword = async () => {
        // Reset any previous errors
        setResetPasswordError("");
        
        // Validate email
        if (!resetPasswordEmail) {
            setResetPasswordError("Email address is required");
            return;
        }
        
        setResetPasswordLoading(true);
        
        try {
            const response = await resetPassword(resetPasswordEmail);
            
            if (response.status === "error") {
                setResetPasswordError(response.message || "Failed to reset password. Please try again.");
                setResetPasswordLoading(false);
            } else {
                // Success - go back to login form
                setResetPasswordLoading(false);
                setShowResetPasswordForm(false);
                
                // Clear the email field
                setResetPasswordEmail("");
                
                // Show success message
                Swal.fire({
                    title: "Password Reset Email Sent",
                    text: "We've sent instructions to reset your password to your email address. Please check your inbox.",
                    icon: "success",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#FFB02E"
                });
            }
        } catch (error) {
            console.error("Error during password reset:", error);
            setResetPasswordError("An unexpected error occurred. Please try again.");
            setResetPasswordLoading(false);
        }
    };

    const handleKeyDownResetPassword = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            handleResetPassword();
        }
    };

    const openPromptusSubscription = (e) => {
        console.log(`Opening Promptus Subscription Plan Page`);
        if (electronBridge.isElectron) {
            ipcRenderer.send('open-urlInExternal', `https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`)
        } else {
            window.open(`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/subscriptions`, '_blank');
        }
    };

    const handleUndeliveredCheck = async () => {
        console.log("[BUTTON] Manual undelivered images check triggered");
        await checkingUndeliveredImages();
    };

    async function onFile(e) {
        const file = e.target.files?.[0];
        if (!file) return;
        const result = await analyzeImage(file);
        console.log('[AlphaCheckTest] analysis report: ', result);
        const alphaTrue = await classifyAlpha(result);
        console.log('[AlphaCheckTest] alpha exists: ', alphaTrue);
      }
    
    const manageSubscription = async() => {
        console.log(`Open manager button pressed`);
        const response = await getSubscriptionPortal();
        if (response && !response.error && response.url !== "") {
            if (electronBridge.isElectron) {
                ipcRenderer.send('open-urlInExternal', response.url)
            } else {
                window.open(response.url, '_blank');
            }
        }
    }  

    return (
        <div className={"px-4 relative w-full max-lg:mx-auto"}>
            <h2 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                <hr className={"mr-2 flex-grow border border-white/40 bg-white/40"} />
                <span>Profile</span>
                <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"} />
            </h2>
            <div className="flex justify-end mb-2">
                <ContextualVideoLink tutorialCategoryId={4} />
            </div>
            {/* Main Content Box */}
            <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto"}>
                {/* Subscription pricing - show at top only when logged in */}
                {accountContext.loggedIn && (
                    <div>
                        <stripe-pricing-table
                            pricing-table-id="prctbl_1SZWa7Ac2NzP5ncKFX3U0Iks"
                            publishable-key="pk_live_51QDlHKAc2NzP5ncKAdXpA7YFW0WVOy3EGw6c5cSzUHDPt9I1otDZ72dxDDhZXzJGcJBV8N0SuhAHJwYOnCJhDZZu00H3v8kZ1k"
                            client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                            customer-email={accountContext.accountDetails.emailAddress}>
                        </stripe-pricing-table>
                    </div>
                )}
                {loading ? <div className={"font-bold"}>Loading stored settings.</div> : null}

                {/* <div>
                    <h1>AI 3D Preview</h1>
                    <ModelCanvas image={'https://images.promptus.ai/output/bc1abbf6d86ecc31ee7811e52d3b6836/68716371707380647d052603fab90b37.glb'} />
                </div> */}
                {/* <button onClick={tester}>test</button> */}
                {/* Purchase Credits Section */}
                {accountContext.loggedIn ? (
                <div className={"bg-dark-blue/30 flex flex-col p-5 w-full border-t"}>
                    {!showSubscription ? (
                        <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowSubscription(true)}>
                            Purchase Credits
                        </h3>
                    ) : (
                        <>
                            <div className="flex flex-row justify-between items-center">
                                <h3 className="text-lg font-bold py-1">Credits Purchase</h3>
                                <button type="button" onClick={() => setShowSubscription(false)}>
                                    <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                </button>
                            </div>
                            {/* <stripe-pricing-table 
                                pricing-table-id="prctbl_1SVcOMAbZMofvOE9C4Gkqp8I"
                                publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table> */}
                            <stripe-pricing-table 
                                pricing-table-id="prctbl_1SYOQEAc2NzP5ncK8L7XCmei"
                                publishable-key="pk_live_51QDlHKAc2NzP5ncKAdXpA7YFW0WVOy3EGw6c5cSzUHDPt9I1otDZ72dxDDhZXzJGcJBV8N0SuhAHJwYOnCJhDZZu00H3v8kZ1k" 
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table>

                            {/* <stripe-pricing-table 
                                pricing-table-id="prctbl_1SVcPyAbZMofvOE9Mc1WqFd0"
                                publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table> */}
                            <stripe-pricing-table 
                                pricing-table-id="prctbl_1SYOTLAc2NzP5ncKBt0YR4Is"
                                publishable-key="pk_live_51QDlHKAc2NzP5ncKAdXpA7YFW0WVOy3EGw6c5cSzUHDPt9I1otDZ72dxDDhZXzJGcJBV8N0SuhAHJwYOnCJhDZZu00H3v8kZ1k"  
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table>

                            {/* <stripe-pricing-table 
                                pricing-table-id="prctbl_1SVcQWAbZMofvOE9an47PVHl"
                                publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table> */}
                            <stripe-pricing-table 
                                pricing-table-id="prctbl_1SYOX5Ac2NzP5ncKmJathy7U"
                                publishable-key="pk_live_51QDlHKAc2NzP5ncKAdXpA7YFW0WVOy3EGw6c5cSzUHDPt9I1otDZ72dxDDhZXzJGcJBV8N0SuhAHJwYOnCJhDZZu00H3v8kZ1k"  
                                client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                customer-email={accountContext.accountDetails.emailAddress}>
                            </stripe-pricing-table>
                        </>
                    )}
                </div>
                )
                :
                null    
                }
                <hr className={"mt-5 flex-grow border border-white/40 bg-white/40"}/>
                {/* Display Account Number if available */}
                {accountContext.accountDetails.accountNo && (
                    <div className={"text-lg p-5 text-center"}>
                        Account Number: {accountContext.accountDetails.accountNo}
                    </div>
                )}

                {/* Open Manager Button (Logged In) */}
                {accountContext.loggedIn && (
                    <>
                        <a onClick={handleOpenManager}
                           className="rounded w-1/2 mx-auto mt-1 mb-3 p-2 bg-yellow text-center text-dark-blue shadow font-bold cursor-pointer">Open Manager</a>
                        <hr className={"mt-5 flex-grow border border-white/40 bg-white/40"}/>
                    </>
                )}

                {/* Conditional Rendering: Logged In vs Logged Out */}
                {!accountContext.loggedIn ? (
                    // NOT SIGNED IN - LOGIN FORM
                    <>
                        <h3 className="text-lg font-bold pt-10 pb-5">
                            {showRegisterForm ? "Create Account" : (showResetPasswordForm ? "Reset Password" : "Log In")}
                        </h3>

                        {/* Google Sign In - Only show in login mode (not in register or reset password mode) */}
                        {!showResetPasswordForm && (
                            <div className="flex flex-col">
                                <div className={"py-2 pt-0"}>
                                    {showGoogleSignIn && (
                                        <button
                                            className={`w-full rounded-lg bg-white shadow-lg p-4 my-5 text-gray-700 flex flex-row items-center justify-between ${googleSignInLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                            onClick={handleGoogleSignIn}
                                            disabled={googleSignInLoading}
                                        >
                                            <span>
                                                <img className="inline-block mr-2 h-6" src={GoogleIcon} alt="Google Icon"/>
                                                {googleSignInLoading ? 'Connecting to Google...' : `${showRegisterForm ? 'Register' : 'Log In'} with Google`}
                                            </span>
                                            {googleSignInLoading ? (
                                                <div className="animate-spin h-6 w-6 border-2 border-gray-500 rounded-full border-t-transparent"></div>
                                            ) : (
                                                <img src={ChevronRight} className="h-6" alt="Arrow Right"/>
                                            )}
                                        </button>
                                    )}
                                </div>
                                {externalLoginError && (
                                    <div className="w-3/4 mx-auto my-3 p-2 bg-red-100 border border-red-400 text-red-700 text-center font-semibold rounded">
                                        {externalLoginErrorMsg}
                                    </div>
                                )}
                                <hr/>
                            </div>
                        )}

                        {/* Login Form - Show only in login mode (not in register or reset password mode) */}
                        {!showRegisterForm && !showResetPasswordForm ? (
                            <div className="flex flex-col">
                                <div className={"py-2 pt-5"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">Email Address</label>
                                    <input type="text" name="emailAddress" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)}
                                        className="w-full rounded-lg text-dark-blue border-0 p-2"
                                        placeholder="Email Address"/>
                                </div>
                                <div className={"py-2 relative"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="password">Password</label>
                                    <input type={passwordVisibility ? "text" : "password"} name="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDownEmail}
                                        className="w-full rounded-lg text-dark-blue border-0 p-2 pr-10" // Added padding-right
                                        placeholder="Password"/>
                                    <button type="button" className="w-9 absolute inset-y-0 right-0 top-7 flex items-center justify-center text-dark-blue" onClick={() => setPasswordVisibility(!passwordVisibility)}>
                                        <img src={passwordVisibility ? PasswordShown : PasswordHidden} alt={passwordVisibility ? "Hide password" : "Show password"} className="h-5"/>
                                    </button>
                                </div>
                                <div className="flex flex-row justify-between mt-2">
                                    <a onClick={() => setShowResetPasswordForm(true)} className="font-semibold text-sm hover:text-yellow cursor-pointer">Forgot your password?</a>
                                    <a onClick={() => setShowRegisterForm(true)} className="font-semibold text-sm hover:text-yellow cursor-pointer">Don't have an account? Register</a>
                                </div>
                                {error && (
                                    <div className="w-3/4 mx-auto my-3 p-2 bg-red-100 border border-red-400 text-red-700 text-center font-semibold rounded">
                                        {error}
                                    </div>
                                )}
                                <button onClick={login} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold disabled:opacity-50" disabled={logloading}>
                                    {logloading ? (
                                        <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                        </svg>
                                    ) : null}
                                    Log In
                                </button>

                                {apiKeyLoginEnabled && (<>
                                <div className="flex items-center my-4">
                                    <hr className="flex-grow border border-white/40"/>
                                    <span className="px-3 text-sm text-white/60">OR</span>
                                    <hr className="flex-grow border border-white/40"/>
                                </div>

                                <button
                                    onClick={() => setShowApiKeyForm(!showApiKeyForm)}
                                    className="text-sm font-semibold text-yellow hover:text-yellow/80 cursor-pointer text-center"
                                >
                                    {showApiKeyForm ? 'Hide API Key Login' : 'Login with API Key'}
                                </button>

                                {showApiKeyForm && (
                                    <div className="flex flex-col mt-3">
                                        <div className="py-2">
                                            <label className="block mb-2 text-sm font-medium" htmlFor="apiKeyEmailInput">Email Address</label>
                                            <input
                                                type="email"
                                                name="apiKeyEmailInput"
                                                value={apiKeyEmailInput}
                                                onChange={(e) => setApiKeyEmailInput(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleApiKeyLogin(); }}
                                                className="w-full rounded-lg text-dark-blue border-0 p-2"
                                                placeholder="Email Address"
                                            />
                                        </div>
                                        <div className="py-2">
                                            <label className="block mb-2 text-sm font-medium" htmlFor="apiKeyInput">API Key</label>
                                            <input
                                                type="password"
                                                name="apiKeyInput"
                                                value={apiKeyInput}
                                                onChange={(e) => setApiKeyInput(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleApiKeyLogin(); }}
                                                className="w-full rounded-lg text-dark-blue border-0 p-2"
                                                placeholder="API Key"
                                            />
                                        </div>
                                        {apiKeyError && (
                                            <div className="w-3/4 mx-auto my-3 p-2 bg-red-100 border border-red-400 text-red-700 text-center font-semibold rounded">
                                                {apiKeyError}
                                            </div>
                                        )}
                                        <button
                                            onClick={handleApiKeyLogin}
                                            className="rounded w-1/2 mx-auto mt-4 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold disabled:opacity-50"
                                            disabled={apiKeyLoading || !apiKeyInput.trim() || !apiKeyEmailInput.trim()}
                                        >
                                            {apiKeyLoading ? (
                                                <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                                </svg>
                                            ) : null}
                                            Verify & Login
                                        </button>
                                    </div>
                                )}
                                </>)}
                            </div>
                        ) : showRegisterForm ? (
                            /* Registration Form - Show only if in register mode */
                            <div className="flex flex-col">
                                <div className={"py-2"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="registerEmail">Email Address</label>
                                    <input 
                                        type="email" 
                                        name="registerEmail" 
                                        value={registerEmail} 
                                        onChange={(e) => setRegisterEmail(e.target.value)} 
                                        className="w-full rounded-lg text-dark-blue border-0 p-2" 
                                        placeholder="Email Address"
                                    />
                                </div>
                                <div className={"py-2 relative"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="registerPassword">Password</label>
                                    <input 
                                        type={registerPasswordVisibility ? "text" : "password"} 
                                        name="registerPassword" 
                                        value={registerPassword} 
                                        onChange={(e) => setRegisterPassword(e.target.value)} 
                                        className="w-full rounded-lg text-dark-blue border-0 p-2 pr-10" 
                                        placeholder="Password"
                                    />
                                    <button 
                                        type="button" 
                                        className="w-9 absolute inset-y-0 right-0 top-7 flex items-center justify-center text-dark-blue" 
                                        onClick={() => setRegisterPasswordVisibility(!registerPasswordVisibility)}
                                    >
                                        <img 
                                            src={registerPasswordVisibility ? PasswordShown : PasswordHidden} 
                                            alt={registerPasswordVisibility ? "Hide password" : "Show password"} 
                                            className="h-5"
                                        />
                                    </button>
                                </div>
                                <div className={"py-2 relative"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="confirmPassword">Confirm Password</label>
                                    <input 
                                        type={registerPasswordVisibility ? "text" : "password"} 
                                        name="confirmPassword" 
                                        value={registerConfirmPassword} 
                                        onChange={(e) => setRegisterConfirmPassword(e.target.value)} 
                                        onKeyDown={handleKeyDownRegister}
                                        className="w-full rounded-lg text-dark-blue border-0 p-2 pr-10" 
                                        placeholder="Confirm Password"
                                    />
                                </div>
                                <div className="flex flex-row justify-end mt-2">
                                    <a onClick={() => setShowRegisterForm(false)} className="font-semibold text-sm hover:text-yellow cursor-pointer">Already have an account? Log in</a>
                                </div>
                                {registerError && (
                                    <div className="w-3/4 mx-auto my-3 p-2 bg-red-100 border border-red-400 text-red-700 text-center font-semibold rounded">
                                        {registerError}
                                    </div>
                                )}
                                <div className="flex flex-row justify-between mt-4">
                                    <button 
                                        onClick={() => setShowRegisterForm(false)} 
                                        className="rounded w-1/3 mx-auto p-2 bg-gray-500 text-white shadow font-bold"
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={handleRegister} 
                                        className="rounded w-1/3 mx-auto p-2 bg-yellow text-dark-blue shadow font-bold disabled:opacity-50" 
                                        disabled={registerLoading}
                                    >
                                        {registerLoading ? (
                                            <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                            </svg>
                                        ) : null}
                                        Register
                                    </button>
                                </div>
                            </div>
                        ) : (
                            /* Reset Password Form - Show only if in reset password mode */
                            <div className="flex flex-col">
                                <div className={"py-2"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="resetPasswordEmail">Email Address</label>
                                    <input 
                                        type="email" 
                                        name="resetPasswordEmail" 
                                        value={resetPasswordEmail} 
                                        onChange={(e) => setResetPasswordEmail(e.target.value)} 
                                        onKeyDown={handleKeyDownResetPassword}
                                        className="w-full rounded-lg text-dark-blue border-0 p-2" 
                                        placeholder="Email Address"
                                    />
                                </div>
                                <div className="flex flex-row justify-end mt-2">
                                    <a onClick={() => setShowResetPasswordForm(false)} className="font-semibold text-sm hover:text-yellow cursor-pointer">Back to login</a>
                                </div>
                                {resetPasswordError && (
                                    <div className="w-3/4 mx-auto my-3 p-2 bg-red-100 border border-red-400 text-red-700 text-center font-semibold rounded">
                                        {resetPasswordError}
                                    </div>
                                )}
                                <div className="flex flex-row justify-between mt-4">
                                    <button 
                                        onClick={() => setShowResetPasswordForm(false)} 
                                        className="rounded w-1/3 mx-auto p-2 bg-gray-500 text-white shadow font-bold"
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        onClick={handleResetPassword} 
                                        className="rounded w-1/3 mx-auto p-2 bg-yellow text-dark-blue shadow font-bold disabled:opacity-50" 
                                        disabled={resetPasswordLoading}
                                    >
                                        {resetPasswordLoading ? (
                                            <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-2 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                            </svg>
                                        ) : null}
                                        Reset Password
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Subscription pricing - shown below login form for non-logged-in users */}
                        <div className="mt-8 pt-6 border-t border-white/10">
                            <p className="text-sm text-white text-center mb-4">Or subscribe to get started</p>
                            <stripe-pricing-table
                                pricing-table-id="prctbl_1SZWa7Ac2NzP5ncKFX3U0Iks"
                                publishable-key="pk_live_51QDlHKAc2NzP5ncKAdXpA7YFW0WVOy3EGw6c5cSzUHDPt9I1otDZ72dxDDhZXzJGcJBV8N0SuhAHJwYOnCJhDZZu00H3v8kZ1k">
                            </stripe-pricing-table>
                        </div>
                    </>
                ) : (
                    // SIGNED IN - ACCOUNT DETAILS
                    <>
                        <div className="flex flex-row justify-between">
                            <h3 className="text-lg font-bold py-5">Account Details</h3>
                            {showManageSub ? (
                                <button className="bg-yellow text-dark-blue my-4 px-2 rounded font-semibold" onClick={() => manageSubscription()}>Manage Subscription</button>
                            )
                            :
                            null
                            }
                        </div>
                        {/* Account Info Display */}
                        <div className="bg-dark-blue/50 p-5 rounded-lg"> {/* Slightly darker background */}
                            <div className="flex flex-row justify-between items-center"> {/* Align items center */}
                                <div>
                                    <h1 className="text-2xl capitalize text-yellow font-bold">{accountContext.accountDetails.alias || "No Username"}</h1>
                                    <h2 className="text-base text-gray-300">{accountContext.accountDetails.emailAddress}</h2> {/* Use h2 and style */}
                                    {isLifetimeLicence() && (
                                        <p className="text-sm text-green-400 mt-1">Application with lifetime licence purchased</p>
                                    )}
                                </div>
                                <div className="flex items-center"> {/* Align token icon and value */}
                                    <img src={TokenIcon} alt="Token Icon" className="h-6 mr-2" /> {/* Adjusted size */}
                                    <span className="text-xl font-semibold">{accountContext.tokens ?? '...'}</span> {/* Use span */}
                                </div>
                            </div>
                        </div>
                        {/* Buttons: Public Gallery / View Prompts / Logout */}
                        <div className="grid grid-cols-4 gap-3 mt-6"> {/* Changed to grid-cols-3 */}
                            <button onClick={viewPublicGallery} className="rounded w-full p-2 bg-yellow text-dark-blue shadow font-bold text-center cursor-pointer hover:bg-yellow-500 disabled:opacity-50" disabled={!accountContext.accountDetails.alias}>View Public Gallery</button>
                            <button onClick={handleUndeliveredCheck} className="rounded w-full p-2 bg-yellow text-dark-blue shadow font-bold text-center cursor-pointer hover:bg-yellow-500 disabled:opacity-50">Fetch Undelivered Images</button>
                            <button onClick={() => setShowPromptHistory(!showPromptHistory)} className="rounded w-full p-2 bg-yellow text-dark-blue shadow font-bold text-center cursor-pointer hover:bg-yellow-500">
                                {showPromptHistory ? 'Hide Prompts' : 'View Prompts'}
                            </button>
                            <button onClick={logout} className="rounded w-full p-2 bg-yellow text-dark-blue shadow font-bold hover:bg-yellow-500 disabled:opacity-50" disabled={logoutloading}> {/* Changed styles */} 
                            {logoutloading ? (
                                <svg aria-hidden="true" role="status" className="inline w-5 h-5 mr-2 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    {/* SVG paths - changed fill color */}
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#190A4E"/> {/* Changed fill */}
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                </svg>
                            ) : null}
                                Log Out
                            </button>
                        </div>
                    </>
                )}
            </div>

            {/* Additional Sections Wrapper (Logged In Only) */}
            {accountContext.loggedIn && (
                <div className="mt-10 space-y-10"> {/* Add margin top and space between sections */}
                    {/* Purchase Credits Section */}
                    {/* <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto"}>
                        {!showSubscription ? (
                            <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowSubscription(true)}>
                                Purchase Credits
                            </h3>
                        ) : (
                            <>
                                <div className="flex flex-row justify-between items-center">
                                    <h3 className="text-lg font-bold py-1">Credits Purchase</h3>
                                    <button type="button" onClick={() => setShowSubscription(false)}>
                                        <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                    </button>
                                </div>
                                <stripe-pricing-table 
                                    pricing-table-id="prctbl_1SVcOMAbZMofvOE9C4Gkqp8I"
                                    publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                    client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                    customer-email={accountContext.accountDetails.emailAddress}>
                                </stripe-pricing-table>

                                <stripe-pricing-table 
                                    pricing-table-id="prctbl_1SVcPyAbZMofvOE9Mc1WqFd0"
                                    publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                    client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                    customer-email={accountContext.accountDetails.emailAddress}>
                                </stripe-pricing-table>

                                <stripe-pricing-table 
                                    pricing-table-id="prctbl_1SVcQWAbZMofvOE9an47PVHl"
                                    publishable-key="pk_test_51SQsPpAbZMofvOE9q5mK4as6TleGtWwVqXFaNqAAGuvUC2m1e0Djyl5T0yN6Kfx8rzyJHvey56kpfLcPVyUO9Q9o00TJN6lBB8"
                                    client-reference-id={`${electronBridge.isElectron ? 'PWA' : 'PWEB'}_${accountContext.accountDetails.accountNo}`}
                                    customer-email={accountContext.accountDetails.emailAddress}>
                                </stripe-pricing-table>
                            </>
                        )}
                    </div> */}

                    {/* Prompt History Section */}
                    <div className={`bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto`}>
                        {!showPromptHistory ? (
                            <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowPromptHistory(true)}>
                                Prompt History
                            </h3>
                        ) : (
                            <>
                                <div className="flex flex-row justify-between items-center">
                                    <h3 className="text-lg font-bold py-1">Prompt History</h3>
                                    <button type="button" onClick={() => setShowPromptHistory(false)}>
                                        <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                    </button>
                                </div>
                                <div className="bg-dark-blue/50 p-4 rounded-lg mt-5 max-h-96 overflow-y-auto"> 
                                    {promptHistory.length > 0 ? promptHistory.map((item, index) => (
                                        <div key={index} className="bg-white/10 p-4 rounded-lg mb-4 hover:bg-white/20 transition cursor-pointer" onClick={() => handlePromptClick(item)}>
                                            <p className="text-lg mb-2 break-words">{item.prompt}</p> 
                                            <div className="flex flex-wrap gap-2 mt-2"> 
                                                {item.seeds && item.seeds.map((seed, seedIndex) => (
                                                    <span key={seedIndex} className="bg-yellow text-dark-blue px-2 py-1 rounded text-xs font-medium">
                                                        Seed: {seed}
                                                    </span>
                                                ))}
                                            </div>
                                            <p className="text-xs text-gray-400 mt-2 text-right"> 
                                                {new Date(item.timestamp || Date.now()).toLocaleString()}
                                            </p>
                                        </div>
                                    )) : <p className="text-center text-gray-400 py-4">No prompt history yet.</p>}
                                </div>
                            </>
                        )}
                    </div>

                    {/* Username Section */}
                    {allowSetUser && (
                        <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto"}>
                            {!showChangeUser ? (
                                <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowChangeUser(true)}>
                                    Change Username
                                </h3>
                            ) : (
                                <>
                                    <div className="flex flex-row justify-between items-center">
                                        <h3 className="text-lg font-bold py-1">Change Username</h3>
                                        <button type="button" onClick={() => setShowChangeUser(false)}>
                                            <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                        </button>
                                    </div>
                                    <div className={"bg-dark-blue/50 p-4 pb-6 rounded-lg mt-5"}>
                                        {newUsername && newUsername !== "" && (
                                            <p className="text-base mb-3">Currently logged in as <span className="text-blue-300 font-semibold">{account.alias}</span></p>
                                        )}
                                        <div className="flex flex-row gap-2">
                                            <input 
                                                type="text" 
                                                value={newUsername}
                                                onChange={e => setNewUsername(e.target.value)}
                                                className="w-full text-dark-blue border-0 rounded px-3 py-2"
                                                placeholder="Enter a new username"
                                            />
                                            <button 
                                                className="px-4 py-2 bg-yellow text-dark-blue shadow font-bold hover:bg-yellow-500 rounded"
                                                onClick={changeUsername}
                                            >
                                                Save
                                            </button>
                                        </div>
                                        {changeError && (
                                            <p className="text-red-400 mt-2">{changeError}</p>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* Profile Photo Section */}
                    <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto"}>
                        {!showProfilePhoto ? (
                            <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowProfilePhoto(true)}>
                                Profile Photo
                            </h3>
                        ) : (
                            <>
                                <div className="flex flex-row justify-between items-center">
                                    <h3 className="text-lg font-bold py-1">Profile Photo</h3>
                                    <button type="button" onClick={() => setShowProfilePhoto(false)}>
                                        <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                    </button>
                                </div>
                                <div className={"bg-dark-blue/50 p-4 pb-6 rounded-lg mt-5 flex flex-col items-center"}>
                                    {profilePhoto ? (
                                        <div className="relative mb-4">
                                            <img 
                                                src={profilePhoto} 
                                                alt="Profile" 
                                                className="w-32 h-32 rounded-full object-cover border-2 border-amber-500"
                                            />
                                            <button 
                                                onClick={clearProfilePhoto}
                                                className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="w-32 h-32 rounded-full bg-dark-blue/70 flex items-center justify-center text-gray-400 border-2 border-gray-600 mb-4">
                                            No Photo
                                        </div>
                                    )}
                                    
                                    <p className="text-sm text-gray-300 mb-4 text-center">
                                        Upload a profile photo that will be displayed in the Generate page above your tokens count.
                                    </p>
                                    
                                    <label className="rounded w-1/2 mx-auto p-2 bg-yellow text-dark-blue shadow font-bold hover:bg-yellow-500 cursor-pointer text-center">
                                        Choose Photo
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            onChange={handleProfilePhotoChange} 
                                            className="hidden"
                                        />
                                    </label>
                                    <p className="text-xs text-gray-400 mt-2 text-center">Recommended: Square image for best results</p>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Model Manager Section */}
                    <div className={"bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto"}>
                            {!showModelManager ? (
                                <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => { setShowModelManager(true); fetchModelFiles(); }}>
                                    Model Manager
                                </h3>
                            ) : (
                                <>
                                    <div className="flex flex-row justify-between items-center">
                                        <h3 className="text-lg font-bold py-1">Model Manager</h3>
                                        <div className="flex items-center gap-2">
                                            <button type="button" onClick={fetchModelFiles} className="text-sm text-yellow hover:text-yellow/80 font-semibold" disabled={modelManagerLoading}>
                                                {modelManagerLoading ? 'Loading...' : 'Refresh'}
                                            </button>
                                            <button type="button" onClick={() => setShowModelManager(false)}>
                                                <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="bg-dark-blue/50 p-4 rounded-lg mt-5">
                                        {modelManagerLoading ? (
                                            <div className="flex justify-center py-8">
                                                <div className="w-10 h-10 border-4 border-white/20 border-t-yellow rounded-full animate-spin" />
                                            </div>
                                        ) : modelManagerError ? (
                                            <p className="text-red-400 text-center py-4">{modelManagerError}</p>
                                        ) : modelFiles.length === 0 ? (
                                            <p className="text-center text-gray-400 py-4">No model files found.</p>
                                        ) : (() => {
                                            const usedModels = modelFiles.filter(f => f.used_by_cosyflows && f.used_by_cosyflows.length > 0);
                                            const unusedModels = modelFiles.filter(f => !f.used_by_cosyflows || f.used_by_cosyflows.length === 0);
                                            const totalSize = modelFiles.reduce((sum, f) => sum + f.size, 0);
                                            return (
                                                <>
                                                    <div className="flex justify-between items-center mb-4 pb-3 border-b border-white/10">
                                                        <span className="text-sm text-gray-300">{modelFiles.length} model file{modelFiles.length !== 1 ? 's' : ''}</span>
                                                        <span className="text-sm font-semibold text-yellow">Total: {formatFileSize(totalSize)}</span>
                                                    </div>
                                                    {usedModels.length > 0 && (
                                                        <div className="mb-6">
                                                            <h4 className="text-base font-semibold text-cyan mb-3">Used by Cosyflows ({usedModels.length})</h4>
                                                            <div className="space-y-2 max-h-64 overflow-y-auto">
                                                                {usedModels.map((model, idx) => (
                                                                    <div key={idx} className="bg-white/5 p-3 rounded-lg">
                                                                        <div className="flex justify-between items-start">
                                                                            <span className="text-sm font-medium break-all pr-2">{model.filename}</span>
                                                                            <span className="text-xs text-yellow whitespace-nowrap">{formatFileSize(model.size)}</span>
                                                                        </div>
                                                                        <div className="flex flex-wrap gap-1 mt-2">
                                                                            {model.used_by_cosyflows.map((cf, cfIdx) => (
                                                                                <span key={cfIdx} className="bg-cyan/20 text-cyan px-2 py-0.5 rounded text-xs">{cf}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {unusedModels.length > 0 && (
                                                        <div>
                                                            <h4 className="text-base font-semibold text-orange mb-3">Not Used by Any Cosyflow ({unusedModels.length})</h4>
                                                            <div className="space-y-2 max-h-64 overflow-y-auto">
                                                                {unusedModels.map((model, idx) => (
                                                                    <div key={idx} className="bg-white/5 p-3 rounded-lg">
                                                                        <div className="flex justify-between items-center">
                                                                            <span className="text-sm font-medium break-all pr-2">{model.filename}</span>
                                                                            <span className="text-xs text-yellow whitespace-nowrap">{formatFileSize(model.size)}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </div>
                                </>
                            )}
                    </div>

                    {/* Hosting Details Section */}
                    <div className={`bg-dark-blue/30 rounded-lg flex flex-col p-5 w-1/2 max-lg-inclusive:w-full mx-auto`}>
                        {!showHostRegister ? (
                            <h3 className="text-lg font-bold py-1 text-center cursor-pointer hover:text-yellow" onClick={() => setShowHostRegister(true)}>
                                Hosting Details
                            </h3>
                        ) : showHostingDetails ? (
                            // Show Hosting Details
                            <>
                                <div className="flex flex-row justify-between items-center">
                                    <h3 className="text-lg font-bold py-1">Hosting Details</h3>
                                    <button type="button" onClick={() => setShowHostRegister(false)}>
                                        <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"> {/* Use grid for better layout */}
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Created:</label> <p>{hostingCreated || 'N/A'}</p></div>
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Order Number:</label> <p>{hostingOrderNumber || 'N/A'}</p></div>
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Domain:</label> <p>{hostingDomain || 'N/A'}</p></div>
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Status:</label> <p>{hostingStatus || 'N/A'}</p></div>
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Initial Invoice (Status):</label> <p>{hostingSetupInvoice || 'N/A'} ({hostingSetupInvoiceStatus || 'N/A'})</p></div>
                                    <div><label className="block pb-1 font-bold text-gray-400 text-sm">Initial Invoice Amount:</label> <p>{process.env.REACT_APP_WHMCS_CURRENCY || '$'} {hostingSetupInvoiceAmount || 'N/A'}</p></div>
                                </div>
                                <div className="flex mt-6">
                                    <a
                                        className="rounded w-auto px-4 mx-auto p-2 bg-yellow text-dark-blue shadow font-bold text-center hover:bg-yellow-500" // Auto width
                                        href={`https://${process.env.REACT_APP_WHMCS_URL}/clientarea.php?action=invoices`}
                                        target="_blank" // Use _blank for safety
                                        rel="noopener noreferrer"
                                    >Go to Hosting Services</a>
                                </div>
                                <div className="w-full mt-6 text-center flex justify-center items-center text-xs text-gray-400"> {/* Adjusted style */}
                                    <span>Powered by</span>
                                    <a href="https://www.mailbox.net.uk/" target="_blank" rel="noopener noreferrer" className="ml-1 hover:text-yellow">
                                        <img className="inline-block h-6" // Adjusted size
                                           src={hostingLogo}
                                           alt="Mailbox Internet Logo"
                                           title="Powered by Mailbox Internet"/>
                                    </a>
                                </div>
                            </>
                        ) : (
                            // Hosting Registration Info
                            <>
                                <div className="flex flex-row justify-between items-center">
                                    <h3 className="text-lg font-bold py-1">Register for Hosting Services</h3>
                                    <button type="button" onClick={() => setShowHostRegister(false)}>
                                        <img src={CloseIcon} alt='Close' className='h-7 hover:opacity-75'/>
                                    </button>
                                </div>
                                <p className="mt-4 text-gray-300">Need hosting for your Promptus creations? Register via our partner.</p> {/* Added description */}
                                <div className="flex mt-6">
                                    <a
                                        className="rounded w-auto px-4 mx-auto p-2 bg-yellow text-dark-blue shadow font-bold text-center hover:bg-yellow-500" // Auto width
                                        href={`https://login.promptus.ai/auto-signin?v=${accountContext.accountDetails.verificationToken}&e=${accountContext.accountDetails.emailHash}&a=${accountContext.accountDetails.accountNo}&r=/account`}
                                        target="_blank" // Use _blank for safety
                                        rel="noopener noreferrer"
                                    >
                                        Click here to register!
                                    </a>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
